// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zVfg","footer":"styles_footer__3_joc"};